<div id="login_modal" class="" role="dialog">
    <div class="modal-content">
        <div class="modal-body mt-5 mb-5">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><i class="fa-solid fa-xmark" (click)="dismiss()"></i></span>
            </button>
            <div class="row">
                <div class="col-md-6">

                </div>
                <div class="col-md-6">
                    <div class="login_here">
                        <form id="login-form" class="form_login" [formGroup]="changePassword">
                            <h3 class="text-center"><img loading="lazy" src="../../../assets/images/new/myvip_logo.png"></h3>
                            <h3 class="text-center">Change password</h3>
                            <div class="form-group">
                                <input type="password" autocomplete="off" class="form-control" formControlName="old_password"
                                    id="old_password" placeholder="Old Password">
                                <ng-container *ngIf="submitted && changeV.old_password.errors">
                                    <p class="error-message" *ngIf=" changeV.old_password.errors.required">
                                        Old Password is required!
                                    </p>
                                    <p class="error-message" *ngIf=" changeV.old_password.errors.minlength">
                                        Password should be minimum of 5 characters.
                                    </p>
                                </ng-container>
                            </div>
                            <div class="form-group">
                                <input type="password" autocomplete="off" class="form-control" formControlName="new_password"
                                    id="new_password" placeholder="New Password">
                                <ng-container *ngIf="submitted && changeV.new_password.errors">
                                    <p class="error-message" *ngIf=" changeV.new_password.errors.required">
                                        New Password is required!
                                    </p>
                                    <p class="error-message" *ngIf=" changeV.new_password.errors.minlength">
                                        Password should be minimum of 5 characters.
                                    </p>
                                </ng-container>
                            </div>
                            <div class="form-group">
                                <input type="password" autocomplete="off" class="form-control" formControlName="confirm_password"
                                    id="confirm_password" placeholder="Confirm Password">
                                <ng-container *ngIf="submitted && changeV.confirm_password.errors">
                                    <p class="error-message" *ngIf=" changeV.confirm_password.errors.required">
                                        Confirm Password is required!
                                    </p>
                                    <p class="error-message" *ngIf=" changeV.confirm_password.errors.minlength">
                                        Password should be minimum of 5 characters.
                                    </p>
                                </ng-container>
                            </div>
                            <div class="form-group">
                                <div class="row align-items-center">
                                    <div class="col-md-12 text-center">
                                        <div class="login_button mt-4">
                                            <a class="btn_design sing_in_btn" (click)="change_password()"> Change password </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>